import { isPersisted } from '@tunasong/schemas'
import type { Poll } from '@tunasong/schemas'
import type { TunaPluginContentProps } from '@tunasong/plugin-lib'
import type { FC } from 'react'
import Responses from '../responses.js'
import invariant from 'tiny-invariant'

export interface ContentViewProps {}

export const ResponsesView: FC<TunaPluginContentProps<Poll>> = props => {
  const { element } = props

  if (!isPersisted(element)) {
    return <>Poll is not persisted</>
  }
  invariant(isPersisted(element), 'Poll must be persisted')

  return <Responses poll={element} />
}

export default ResponsesView
